import {
  EARTH_EXCITED,
  EARTH_WEAR_HAT,
  EARTH_WEAR_GLASSES,
  GURU_GLOBE,
  STAR_GLOBE,
  SPELLING,
  DICTIONARY,
  FEATHER,
  SKATEBOARD,
  PAINT,
  SLEEP_GLOBE,
  HAPPY_GLOBE,
  HEART_GLOBE,
  GLOBAL_SHOCK,
  EARTH_SING,
  GLOBE_HUG,
  STARTUP,
  SUITCASE,
  HELMET,
  BRIEFCASE,
  COFFEE,
  HEART,
  FOOD,
  DOUBLE_HEART,
  HIGH_FIVE,
  MAGNIFIER,
  STORE,
  FACEBOOK_INSTA,
  TIKTOK_YOUTUBE,
  PODCAST,
  MEGAPHONE,
  THREE_DOTS,
  APPLE_LOGO,
  AWARDS,
  PLAYSTORE_LOGO,
  POINTER_ICON,
  ENGAGING_ACTIVITY,
  MIX_LANGUAGES,
  PROVEN_RESULTS,
  EVENINGPOST_LOGO,
  BUZZFEED_LOGO,
  VOGUE_LOGO,
  GUARANTEE_BACK,
  GROW_SKILLS,
  TWO_MINUTES,
  THREE_MINUTES,
  FIVE_MINUTES,
  AND_MORE_STEP,
  SAMPLE_USER_1,
  SAMPLE_USER_2,
  SAMPLE_USER_3,
  SAMPLE_USER,
} from '@/sharedModules/images/index.web';

type PlanType = 'monthly' | 'quarterly' | 'yearly';

export const labels = [
  'en',
  'af',
  'am',
  'ar',
  'bg',
  'bn',
  'bs',
  'ca',
  'cs',
  'da',
  'de',
  'dialog-headers',
  'el',
  'en-US',
  'es',
  'et',
  'fa',
  'fi',
  'fil',
  'fr',
  'ga',
  'grammar-headers-en',
  'grammar-headers-th',
  'gu',
  'he',
  'hi',
  'hr',
  'hu',
  'hy',
  'id',
  'in',
  'it',
  'ja',
  'ka',
  'kk',
  'km',
  'kn',
  'ko',
  'lo',
  'lt',
  'lv',
  'mv',
  'mn',
  'mr',
  'ms',
  'my',
  'ne',
  'nl',
  'no',
  'pl',
  'ps',
  'pt',
  'pu',
  'ro',
  'ru',
  'sb',
  'sk',
  'sl',
  'sq',
  'sr',
  'sv',
  'sw',
  'ta',
  'te',
  'th',
  'tr',
  'uk',
  'ur',
  'vi',
  'yo',
  'yue',
  'zh-cn',
  'zh-TW',
  'zh',
  'ceb',
  'is',
  'si',
  'so',
  'az',
  'jv',
  'mi',
  'nan',
  'su',
  'uz',
];

export const age = [
  { id: 1, icon: '🐷', name: '12-17', value: '12-17' },
  { id: 2, icon: '🐰', name: '18-24', value: '18-24' },
  { id: 3, icon: '🐮', name: '25-34', value: '25-34' },
  { id: 4, icon: '🦊', name: '35-44', value: '35-44' },
  { id: 5, icon: '🐻', name: '45-54', value: '45-54' },
  { id: 6, icon: '🦉', name: '55-65', value: '55-65' },
  { id: 7, icon: '🦁', name: '66+', value: '66+' },
];

export const goals = [
  {
    id: 1,
    icon: EARTH_EXCITED.src,
    text: 'byId.txt_elementary_level.content',
    subText: 'byId.txt_goal_level_basic_topics.content',
    value: 'beginner',
  },
  {
    id: 2,
    icon: EARTH_WEAR_HAT.src,
    text: 'byId.unitLevel_txt_beginner.content',
    subText: 'byId.txt_goal_level_start_communicating.content',
    value: 'elementary',
  },
  {
    id: 3,
    icon: EARTH_WEAR_GLASSES.src,
    text: 'byId.unitLevel_txt_intermediate.content',
    subText: 'byId.txt_goal_level_express_opinions.content',
    value: 'intermediate',
  },
  {
    id: 4,
    icon: GURU_GLOBE.src,
    text: 'byId.unitLevel_txt_advance.content',
    subText: 'byId.txt_goal_level_become_fluent.content',
    value: 'upper-intermediate',
  },
  {
    id: 5,
    icon: STAR_GLOBE.src,
    text: 'byId.unitLevel_txt_proficient.content',
    subText: 'byId.txt_goal_level_become_guru.content',
    value: 'expert',
  },
];

export const improvements = [
  {
    id: 1,
    icon: SPELLING.src,
    text: 'byId.txt_spelling.content',
    subText: '',
    value: 'spelling',
  },
  {
    id: 2,
    icon: DICTIONARY.src,
    text: 'byId.overview_txt_vocab.content',
    subText: '',
    value: 'vocabulary',
  },
  {
    id: 3,
    icon: FEATHER.src,
    text: 'byId.txt_tenses.content',
    subText: '',
    value: 'tenses',
  },
  {
    id: 4,
    icon: SKATEBOARD.src,
    text: 'byId.txt_phrasal_verbs.content',
    subText: '',
    value: 'phrasal verbs',
  },
  {
    id: 5,
    icon: PAINT.src,
    text: 'byId.txt_language_styles.content',
    subText: '',
    value: 'language styles',
  },
];

export const time = [
  {
    id: 1,
    icon: SLEEP_GLOBE.src,
    text: 'byId.txt_time_per_week.content',
    subText: '',
    number: 1,
    value: '1 time per week',
  },
  {
    id: 2,
    icon: HAPPY_GLOBE.src,
    text: 'byId.txt_times_per_week.content',
    subText: '',
    number: 2,
    value: '2 time per week',
  },
  {
    id: 3,
    icon: HEART_GLOBE.src,
    text: 'byId.txt_times_per_week.content',
    subText: '',
    number: 3,
    value: '3 time per week',
  },
  {
    id: 4,
    icon: GURU_GLOBE.src,
    text: 'byId.txt_times_per_week.content',
    subText: '',
    number: 4,
    value: '4 time per week',
  },
  {
    id: 5,
    icon: STAR_GLOBE.src,
    text: 'byId.txt_times_per_week.content',
    subText: '',
    number: 5,
    value: '5 time per week',
  },
];

export const studyPerDay = [
  {
    id: 1,
    icon: GLOBAL_SHOCK.src,
    text: 'byId.survey_question_2_title_choice_1.content',
    subText: 'byId.txt_words_per_week.content',
    number: 25,
    value: '5 min',
  },
  {
    id: 2,
    icon: EARTH_EXCITED.src,
    text: 'byId.survey_question_2_title_choice_2.content',
    subText: 'byId.txt_words_per_week.content',
    number: 50,
    value: '10 min',
  },
  {
    id: 3,
    icon: EARTH_SING.src,
    text: 'byId.survey_question_2_title_choice_3.content',
    subText: 'byId.txt_words_per_week.content',
    number: 75,
    value: '15 min',
  },
  {
    id: 4,
    icon: GLOBE_HUG.src,
    text: 'byId.survey_question_2_title_choice_4.content',
    subText: 'byId.txt_words_per_week.content',
    number: 100,
    value: '20 min',
  },
];

export const interests = [
  {
    id: 1,
    icon: STARTUP.src,
    text: 'byId.txt_technology.content',
    subText: '',
    value: 'technology',
  },
  {
    id: 2,
    icon: SUITCASE.src,
    text: 'byId.units_txt_unit21.content',
    subText: '',
    value: 'traveling',
  },
  {
    id: 3,
    icon: HELMET.src,
    text: 'byId.txt_career.content',
    subText: '',
    value: 'career',
  },
  {
    id: 4,
    icon: BRIEFCASE.src,
    text: 'byId.units_txt_unit41.content',
    subText: '',
    value: 'business',
  },
  {
    id: 5,
    icon: COFFEE.src,
    text: 'byId.txt_daily_life.content',
    subText: '',
    value: 'daily life',
  },
  {
    id: 6,
    icon: HEART.src,
    text: 'byId.txt_health.content',
    subText: '',
    value: 'health & fitness',
  },
  {
    id: 7,
    icon: FOOD.src,
    text: 'byId.btn_food.content',
    subText: '',
    value: 'food',
  },
  {
    id: 8,
    icon: DOUBLE_HEART.src,
    text: 'byId.units_txt_unit28.content',
    subText: '',
    value: 'relationship',
  },
];

export const socialMedias = [
  {
    id: 1,
    icon: HIGH_FIVE.src,
    text: 'byId.survey_question_4_choice_1.content',
    subText: '',
    value: 'friends/family',
  },
  {
    id: 2,
    icon: MAGNIFIER.src,
    text: 'byId.setting_txt_googleSearch.content',
    subText: '',
    value: 'google search',
  },
  {
    id: 3,
    icon: STORE.src,
    text: 'byId.setting_txt_appMarket.content',
    subText: '',
    value: 'google play/app store',
  },
  {
    id: 4,
    icon: FACEBOOK_INSTA.src,
    text: 'byId.survey_question_4_choice_fb_ig.content',
    subText: '',
    value: 'facebook/instagram',
  },
  {
    id: 5,
    icon: TIKTOK_YOUTUBE.src,
    text: 'byId.survey_question_4_choice_tiktok.content',
    text2: 'byId.survey_question_4_choice_youtube.content',
    subText: '',
    value: 'tikTok/youTube',
  },
  {
    id: 6,
    icon: PODCAST.src,
    text: 'byId.survey_question_4_choice_3.content',
    subText: '',
    value: 'podcast',
  },
  {
    id: 7,
    icon: MEGAPHONE.src,
    text: 'byId.survey_question_4_choice_4.content',
    subText: '',
    value: 'ads',
  },
  {
    id: 8,
    icon: THREE_DOTS.src,
    text: 'byId.modal_error_other.content',
    subText: '',
    value: 'other',
  },
];

export const USED_INDIA_FLAG: Array<string> = [
  'hi',
  'kn',
  'ml',
  'pu',
  'te',
  'gu',
  'mr',
];

export const awardsData = [
  {
    logoSrc: APPLE_LOGO,
    rating: '4.7',
    awardSrc: AWARDS,
    descriptionKey: 'byId.txt_featured_on_app_store.content',
  },
  {
    logoSrc: PLAYSTORE_LOGO,
    rating: '4.5',
    awardSrc: AWARDS,
    descriptionKey: 'byId.txt_featured_on_play_store.content',
  },
];

export const PhilosophyData = [
  {
    id: '1',
    ImageSrc: TWO_MINUTES.src,
    Heading: 'byId.txt_2_minutes.content',
    Description: 'byId.txt_dsc_learn_new_words.content',
  },
  {
    id: '2',
    ImageSrc: THREE_MINUTES.src,
    Heading: 'byId.txt_3_minutes.content',
    Description: 'byId.txt_dsc_review_vocabulary.content',
  },
  {
    id: '3',
    ImageSrc: FIVE_MINUTES.src,
    Heading: 'byId.txt_5_minutes.content',
    Description: 'byId.txt_dsc_learn_from_natives.content',
  },
  {
    id: '4',
    ImageSrc: AND_MORE_STEP.src,
    Heading: 'byId.txt_and_more.content',
    Description: 'byId.txt_dsc_explore_lessons.content',
  },
];

export const ReviewsData = [
  {
    id: '1',
    quote: 'byId.txt_review_paywall_favourite_application.content',
    name: 'James Rowland',
    rating: '4.8',
    imageSrc: SAMPLE_USER_1.src,
  },
  {
    id: '2',
    quote: 'byId.txt_review_paywall_fun.content',
    name: 'Sarah Johnson',
    rating: '4.9',
    imageSrc: SAMPLE_USER_2.src,
  },
  {
    id: '3',
    quote: 'byId.txt_review_paywall_good_for_beginners.content',
    name: 'Michael Brown',
    rating: '4.7',
    imageSrc: SAMPLE_USER_3.src,
  },
  {
    id: '4',
    quote: 'byId.txt_review_paywall_practical_application.content',
    name: 'Emily Davis',
    rating: '4.9',
    imageSrc: SAMPLE_USER.src,
  },
  // added duplicate data to make it look like the data is in loop
  {
    id: '5',
    quote: 'byId.txt_review_paywall_favourite_application.content',
    name: 'James Rowland',
    rating: '4.8',
    imageSrc: SAMPLE_USER_1.src,
  },
  {
    id: '6',
    quote: 'byId.txt_review_paywall_fun.content',
    name: 'Sarah Johnson',
    rating: '4.9',
    imageSrc: SAMPLE_USER_2.src,
  },
  {
    id: '7',
    quote: 'byId.txt_review_paywall_good_for_beginners.content',
    name: 'Michael Brown',
    rating: '4.7',
    imageSrc: SAMPLE_USER_3.src,
  },
  {
    id: '8',
    quote: 'byId.txt_review_paywall_practical_application.content',
    name: 'Emily Davis',
    rating: '4.9',
    imageSrc: SAMPLE_USER.src,
  },
];

export const contentData = [
  {
    id: 1,
    imageSrc: POINTER_ICON,
    altText: 'Interactive Exercises',
    headingLabel: 'byId.txt_interactive_exercises.content',
    textLabel: 'byId.txt_dsc_improve_pronunciation.content',
    position: 'right',
  },
  {
    id: 2,
    imageSrc: ENGAGING_ACTIVITY,
    altText: 'Engaging Activities',
    headingLabel: 'byId.txt_engaging_activities.content',
    textLabel: 'byId.txt_dsc_practice_skills.content',
    position: 'right',
  },
  {
    id: 3,
    imageSrc: MIX_LANGUAGES,
    altText: 'Mix Languages',
    headingLabel: 'byId.txt_mix_languages.content',
    textLabel: 'byId.txt_choose_60_languages.content',
    position: 'left',
  },
  {
    id: 4,
    imageSrc: PROVEN_RESULTS,
    altText: 'Proven Results',
    headingLabel: 'byId.txt_proven_results.content',
    textLabel: 'byId.txt_dsc_learning_methods.content',
    position: 'left',
  },
];

export const logos = [
  {
    src: EVENINGPOST_LOGO,
    alt: 'Evening Post',
    width: 200,
    height: 60,
  },
  {
    src: BUZZFEED_LOGO,
    alt: 'BuzzFeed',
    width: 150,
    height: 60,
  },
  {
    src: VOGUE_LOGO,
    alt: 'Vogue',
    width: 150,
    height: 60,
  },
];

export const faqData = [
  {
    id: 'a',
    questionKey: 'byId.txt_faq_how_many_languages.content',
    answerKey: 'byId.txt_faq_answer_how_many_languages.content',
  },
  {
    id: 'b',
    questionKey: 'byId.txt_faq_best_way_to_learn.content',
    answerKey: 'byId.txt_faq_answer_best_way_to_learn.content',
  },
  {
    id: 'c',
    questionKey: 'byId.txt_faq_learn_from_apps.content',
    answerKey: 'byId.txt_faq_answer_learn_from_apps.content',
  },
];

export const guaranteeData = [
  {
    bgColor: '#E6FCD9',
    imageSrc: GUARANTEE_BACK,
    altText: 'Guarantee',
    headingLabel: 'byId.txt_money_back_guarantee.content',
    textLabel: 'byId.txt_dsc_money_back_guarantee.content',
  },
  {
    bgColor: '#FFF9EB',
    imageSrc: GROW_SKILLS,
    altText: 'Grow Skills',
    headingLabel: 'byId.txt_grow_your_skills.content',
    textLabel: 'byId.txt_dsc_personalized_plan.content',
  },
];

export const PaymentPlans = [
  {
    id: 'yearly',
    tagLine: 'byId.txt_free_trial_label.content',
    offerText: 'byId.txt_save_x.content',
    annualOffer: 'byId.txt_dsc_annual_payment_of.content',
  },
  {
    id: 'quarterly',
    offerText: 'byId.purchase_txt_option_popular.content',
    annualOffer: 'byId.txt_dsc_quarterly_payment_of.content',
  },
  {
    id: 'monthly',
    annualOffer: 'byId.txt_dsc_monthly_payment_of.content',
  },
];

export const getPlanText = (planId: PlanType) => {
  switch (planId) {
    case 'yearly':
      return {
        planName: 'byId.txt_1_year.content',
        planDescription: 'byId.txt_with_7_day_trial.content',
      };
    case 'quarterly':
      return {
        planName: 'byId.txt_3_months.content',
      };
    case 'monthly':
      return {
        planName: 'byId.paywall_txt_1_months.content',
      };
    default:
      return {
        planName: 'byId.txt_1_year.content',
        planDescription: 'byId.txt_with_7_day_trial.content',
      };
  }
};

export const DEFAULT_TARGET_LANGUAGE = 'th';
export const DEFAULT_NATIVE_LANGUAGE = 'en';
export const MAXIMUM_STREAK_CHALLENGE = 7;

// Default streak saver values matching mobile app's approved client logic
export const DEFAULT_EARNED_STREAK_SAVER = 1; // Users start with 1 streak saver
export const DEFAULT_REAL_CONSECUTIVE_DAYS = 7; // Users start with 7 consecutive days
